import cx from 'classnames';

import classes from 'components/Form/Input/input.module.scss';

export const ValidationMessage = ({ error = '', absolute = true }: { error?: string; absolute?: boolean }) => {
  if (!error) return null;

  return <div className={cx(classes.error, { [classes.absolute]: absolute })}>{error}</div>;
};
